/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseModuleInput } from '../models/BaseModuleInput';
import type { BaseUpdateModuleInput } from '../models/BaseUpdateModuleInput';
import type { ButtonBlockInput } from '../models/ButtonBlockInput';
import type { CarOfferInfoInput } from '../models/CarOfferInfoInput';
import type { CarOfferItemInput } from '../models/CarOfferItemInput';
import type { ContentLogDto } from '../models/ContentLogDto';
import type { ContentLogImagePosition } from '../models/ContentLogImagePosition';
import type { ContentLogImageType } from '../models/ContentLogImageType';
import type { ContentLogIsVisisbleInput } from '../models/ContentLogIsVisisbleInput';
import type { ContentLogItemDtoPagedListData } from '../models/ContentLogItemDtoPagedListData';
import type { ContentLogMoveInput } from '../models/ContentLogMoveInput';
import type { ContentLogParagraphInput } from '../models/ContentLogParagraphInput';
import type { ContentLogSectionType } from '../models/ContentLogSectionType';
import type { CreateContentLogInput } from '../models/CreateContentLogInput';
import type { CreateNewFAQInput } from '../models/CreateNewFAQInput';
import type { CreateNewFAQItemInput } from '../models/CreateNewFAQItemInput';
import type { NewArrivalBlockInput } from '../models/NewArrivalBlockInput';
import type { TextWithSideImageInput } from '../models/TextWithSideImageInput';
import type { UpdateFAQInput } from '../models/UpdateFAQInput';
import type { UpdateHeaderInput } from '../models/UpdateHeaderInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { SortTypeEnum } from '../models/SortTypeEnum';

export class ContentLogService {

  /**
   * @param pageUrl
   * @param dateFrom
   * @param dateTo
   * @param skipPagination
   * @param page
   * @param maxCount
   * @returns ContentLogItemDtoPagedListData Success
   * @throws ApiError
   */
  public static getContentLog(
    pageUrl?: string,
    dateFrom?: string,
    dateTo?: string,
    skipPagination?: boolean,
    page?: number,
    maxCount?: number,
    order?: SortTypeEnum,
    sort?: string,
  ): CancelablePromise<ContentLogItemDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/content-log',
      query: {
        'PageUrl': pageUrl,
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
        'Sort': sort,
        'Order': order
      },
    });
  }

  /**
   * @param requestBody
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLog(
    requestBody?: CreateContentLogInput,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id
   * @returns ContentLogDto Success
   * @throws ApiError
   */
  public static getContentLog1(
    id: number,
  ): CancelablePromise<ContentLogDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/content-log/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLog(
    id: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogFaq(
    id: number,
    requestBody?: CreateNewFAQInput,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{id}/faq',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param id
   * @param requestBody
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogFaqItems(
    contentLogId: number,
    id: number,
    requestBody?: CreateNewFAQItemInput,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/faq/{id}/items',
      path: {
        'contentLogId': contentLogId,
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param id
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static patchContentLogFaqVisibility(
    contentLogId: number,
    id: number,
    requestBody?: ContentLogIsVisisbleInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/content-log/{contentLogId}/faq/{id}/visibility',
      path: {
        'contentLogId': contentLogId,
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param id
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogFaq(
    contentLogId: number,
    id: number,
    requestBody?: UpdateFAQInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/faq/{id}',
      path: {
        'contentLogId': contentLogId,
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param id
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogFaq(
    contentLogId: number,
    id: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/faq/{id}',
      path: {
        'contentLogId': contentLogId,
        'id': id,
      },
    });
  }

  /**
   * @param contentLogId
   * @param faqId
   * @param id
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogFaqItems(
    contentLogId: number,
    faqId: number,
    id: number,
    requestBody?: CreateNewFAQItemInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/faq/{faqId}/items/{id}',
      path: {
        'contentLogId': contentLogId,
        'faqId': faqId,
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param faqId
   * @param id
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogFaqItems(
    contentLogId: number,
    faqId: number,
    id: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/faq/{faqId}/items/{id}',
      path: {
        'contentLogId': contentLogId,
        'faqId': faqId,
        'id': id,
      },
    });
  }

  /**
   * @param contentLogId
   * @param faqId
   * @param id
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogFaqItemsMove(
    contentLogId: number,
    faqId: number,
    id: number,
    requestBody?: ContentLogMoveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/faq/{faqId}/items/{id}/move',
      path: {
        'contentLogId': contentLogId,
        'faqId': faqId,
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param faqId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogFaqMove(
    contentLogId: number,
    faqId: number,
    requestBody?: ContentLogMoveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/faq/{faqId}/move',
      path: {
        'contentLogId': contentLogId,
        'faqId': faqId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param formData
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogOffer(
    contentLogId: number,
    formData?: {
      Description?: string;
      BottomDescription?: string;
      TechnologyAndCulture?: string;
      ImagePosition?: ContentLogImagePosition;
      Image?: Blob;
      Title?: string;
      IsVisible?: boolean;
    },
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/offer',
      path: {
        'contentLogId': contentLogId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param offerId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogOffer(
    contentLogId: number,
    offerId: number,
    formData?: {
      UpdateImage?: boolean;
      Description?: string;
      BottomDescription?: string;
      TechnologyAndCulture?: string;
      ImagePosition?: ContentLogImagePosition;
      Image?: Blob;
      Title?: string;
      IsVisible?: boolean;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/offer/{offerId}',
      path: {
        'contentLogId': contentLogId,
        'offerId': offerId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param offerId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogOffer(
    contentLogId: number,
    offerId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/offer/{offerId}',
      path: {
        'contentLogId': contentLogId,
        'offerId': offerId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param offerId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static patchContentLogOfferVisibility(
    contentLogId: number,
    offerId: number,
    requestBody?: ContentLogIsVisisbleInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/content-log/{contentLogId}/offer/{offerId}/visibility',
      path: {
        'contentLogId': contentLogId,
        'offerId': offerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param offerId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogOfferMove(
    contentLogId: number,
    offerId: number,
    requestBody?: ContentLogMoveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/offer/{offerId}/move',
      path: {
        'contentLogId': contentLogId,
        'offerId': offerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param offerId
   * @param formData
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogOfferButtons(
    contentLogId: number,
    offerId: number,
    formData?: {
      Label: string;
      Link: string;
    },
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/offer/{offerId}/buttons',
      path: {
        'contentLogId': contentLogId,
        'offerId': offerId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param offerId
   * @param btnId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogOfferButtons(
    contentLogId: number,
    offerId: number,
    btnId: number,
    formData?: {
      Label: string;
      Link: string;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/offer/{offerId}/buttons/{btnId}',
      path: {
        'contentLogId': contentLogId,
        'offerId': offerId,
        'btnId': btnId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param offerId
   * @param btnId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogOfferButtons(
    contentLogId: number,
    offerId: number,
    btnId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/offer/{offerId}/buttons/{btnId}',
      path: {
        'contentLogId': contentLogId,
        'offerId': offerId,
        'btnId': btnId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param offerId
   * @param formData
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogOfferFeatures(
    contentLogId: number,
    offerId: number,
    formData?: {
      Text: string;
    },
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/offer/{offerId}/features',
      path: {
        'contentLogId': contentLogId,
        'offerId': offerId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param offerId
   * @param featureId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogOfferFeatures(
    contentLogId: number,
    offerId: number,
    featureId: number,
    formData?: {
      Text: string;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/offer/{offerId}/features/{featureId}',
      path: {
        'contentLogId': contentLogId,
        'offerId': offerId,
        'featureId': featureId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param offerId
   * @param featureId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogOfferFeatures(
    contentLogId: number,
    offerId: number,
    featureId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/offer/{offerId}/features/{featureId}',
      path: {
        'contentLogId': contentLogId,
        'offerId': offerId,
        'featureId': featureId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param formData
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogNewCarDescription(
    contentLogId: number,
    formData?: {
      Title?: string;
      IsVisible?: boolean;
    },
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/new-car-description',
      path: {
        'contentLogId': contentLogId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogNewCarDescription(
    contentLogId: number,
    descId: number,
    formData?: {
      Title: string;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/new-car-description/{descId}',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogNewCarDescription(
    contentLogId: number,
    descId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/new-car-description/{descId}',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static patchContentLogNewCarDescriptionVisibility(
    contentLogId: number,
    descId: number,
    requestBody?: ContentLogIsVisisbleInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/visibility',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogNewCarDescriptionMove(
    contentLogId: number,
    descId: number,
    requestBody?: ContentLogMoveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/move',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param formData
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogNewCarDescriptionSections(
    contentLogId: number,
    descId: number,
    formData?: {
      SectionName?: string;
      SectionType?: ContentLogSectionType;
      VideoUrl?: string;
      VideoPosition?: ContentLogImagePosition;
      Image?: Blob;
      ImagePosition?: ContentLogImagePosition;
      Text?: string;
    },
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/sections',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param sectionId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogNewCarDescriptionSections(
    contentLogId: number,
    descId: number,
    sectionId: number,
    formData?: {
      UpdateImage?: boolean;
      SectionName?: string;
      SectionType?: ContentLogSectionType;
      VideoUrl?: string;
      VideoPosition?: ContentLogImagePosition;
      Image?: Blob;
      ImagePosition?: ContentLogImagePosition;
      Text?: string;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/sections/{sectionId}',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
        'sectionId': sectionId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param sectionId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogNewCarDescriptionSections(
    contentLogId: number,
    descId: number,
    sectionId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/sections/{sectionId}',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
        'sectionId': sectionId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param sectionId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogNewCarDescriptionSectionsMove(
    contentLogId: number,
    descId: number,
    sectionId: number,
    requestBody?: ContentLogMoveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/sections/{sectionId}/move',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
        'sectionId': sectionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param sectionId
   * @param formData
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogNewCarDescriptionSectionsImageBlocks(
    contentLogId: number,
    descId: number,
    sectionId: number,
    formData?: {
      Title?: string;
      Description?: string;
      Image: Blob;
    },
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/sections/{sectionId}/image-blocks',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
        'sectionId': sectionId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param sectionId
   * @param blockId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogNewCarDescriptionSectionsImageBlocks(
    contentLogId: number,
    descId: number,
    sectionId: number,
    blockId: number,
    formData?: {
      UpdateImage: boolean;
      Title?: string;
      Description?: string;
      Image: Blob;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/sections/{sectionId}/image-blocks/{blockId}',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
        'sectionId': sectionId,
        'blockId': blockId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param sectionId
   * @param blockId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogNewCarDescriptionSectionsImageBlocks(
    contentLogId: number,
    descId: number,
    sectionId: number,
    blockId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/sections/{sectionId}/image-blocks/{blockId}',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
        'sectionId': sectionId,
        'blockId': blockId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param sectionId
   * @param blockId
   * @param formData
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogNewCarDescriptionSectionsImageBlocksFeatures(
    contentLogId: number,
    descId: number,
    sectionId: number,
    blockId: number,
    formData?: {
      Text: string;
    },
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/sections/{sectionId}/image-blocks/{blockId}/features',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
        'sectionId': sectionId,
        'blockId': blockId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param sectionId
   * @param blockId
   * @param featureId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogNewCarDescriptionSectionsImageBlocksFeatures(
    contentLogId: number,
    descId: number,
    sectionId: number,
    blockId: number,
    featureId: number,
    formData?: {
      Text: string;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/sections/{sectionId}/image-blocks/{blockId}/features/{featureId}',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
        'sectionId': sectionId,
        'blockId': blockId,
        'featureId': featureId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param sectionId
   * @param blockId
   * @param featureId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogNewCarDescriptionSectionsImageBlocksFeatures(
    contentLogId: number,
    descId: number,
    sectionId: number,
    blockId: number,
    featureId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/sections/{sectionId}/image-blocks/{blockId}/features/{featureId}',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
        'sectionId': sectionId,
        'blockId': blockId,
        'featureId': featureId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param sectionId
   * @param requestBody
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogNewCarDescriptionSectionsParagraphs(
    contentLogId: number,
    descId: number,
    sectionId: number,
    requestBody?: ContentLogParagraphInput,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/sections/{sectionId}/paragraphs',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
        'sectionId': sectionId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param sectionId
   * @param paragraphId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogNewCarDescriptionSectionsParagraphs(
    contentLogId: number,
    descId: number,
    sectionId: number,
    paragraphId: number,
    requestBody?: ContentLogParagraphInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/sections/{sectionId}/paragraphs/{paragraphId}',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
        'sectionId': sectionId,
        'paragraphId': paragraphId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param descId
   * @param sectionId
   * @param paragraphId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogNewCarDescriptionSectionsParagraphs(
    contentLogId: number,
    descId: number,
    sectionId: number,
    paragraphId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/new-car-description/{descId}/sections/{sectionId}/paragraphs/{paragraphId}',
      path: {
        'contentLogId': contentLogId,
        'descId': descId,
        'sectionId': sectionId,
        'paragraphId': paragraphId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param formData
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogBigSliders(
    contentLogId: number,
    formData?: {
      Title?: string;
      IsVisible?: boolean;
    },
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/big-sliders',
      path: {
        'contentLogId': contentLogId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param bigSliderId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static patchContentLogBigSlidersVisibility(
    contentLogId: number,
    bigSliderId: number,
    requestBody?: ContentLogIsVisisbleInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/content-log/{contentLogId}/big-sliders/{bigSliderId}/visibility',
      path: {
        'contentLogId': contentLogId,
        'bigSliderId': bigSliderId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param bigSliderId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogBigSlidersMove(
    contentLogId: number,
    bigSliderId: number,
    requestBody?: ContentLogMoveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/big-sliders/{bigSliderId}/move',
      path: {
        'contentLogId': contentLogId,
        'bigSliderId': bigSliderId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param bigSliderId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogBigSliders(
    contentLogId: number,
    bigSliderId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/big-sliders/{bigSliderId}',
      path: {
        'contentLogId': contentLogId,
        'bigSliderId': bigSliderId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param bigSliderId
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogBigSlidersItems(
    contentLogId: number,
    bigSliderId: number,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/big-sliders/{bigSliderId}/items',
      path: {
        'contentLogId': contentLogId,
        'bigSliderId': bigSliderId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param bigSliderId
   * @param itemId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogBigSlidersItems(
    contentLogId: number,
    bigSliderId: number,
    itemId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/big-sliders/{bigSliderId}/items/{itemId}',
      path: {
        'contentLogId': contentLogId,
        'bigSliderId': bigSliderId,
        'itemId': itemId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param bigSliderId
   * @param itemId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogBigSlidersItemsImage(
    contentLogId: number,
    bigSliderId: number,
    itemId: number,
    formData?: {
      ImageType: ContentLogImageType;
      File: Blob;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/big-sliders/{bigSliderId}/items/{itemId}/image',
      path: {
        'contentLogId': contentLogId,
        'bigSliderId': bigSliderId,
        'itemId': itemId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param bigSliderId
   * @param itemId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogBigSlidersItemsImage(
    contentLogId: number,
    bigSliderId: number,
    itemId: number,
    formData?: {
      input?: ContentLogImageType;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/big-sliders/{bigSliderId}/items/{itemId}/image',
      path: {
        'contentLogId': contentLogId,
        'bigSliderId': bigSliderId,
        'itemId': itemId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param formData
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogCarOffers(
    contentLogId: number,
    formData?: {
      Title?: string;
      IsVisible?: boolean;
    },
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/car-offers',
      path: {
        'contentLogId': contentLogId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static patchContentLogCarOffersVisibility(
    contentLogId: number,
    blockId: number,
    requestBody?: ContentLogIsVisisbleInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/content-log/{contentLogId}/car-offers/{blockId}/visibility',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogCarOffersMove(
    contentLogId: number,
    blockId: number,
    requestBody?: ContentLogMoveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/car-offers/{blockId}/move',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogCarOffers(
    contentLogId: number,
    blockId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/car-offers/{blockId}',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogCarOffersItems(
    contentLogId: number,
    blockId: number,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/car-offers/{blockId}/items',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @param itemId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogCarOffersItems(
    contentLogId: number,
    blockId: number,
    itemId: number,
    requestBody?: CarOfferItemInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/car-offers/{blockId}/items/{itemId}',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @param itemId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogCarOffersItems(
    contentLogId: number,
    blockId: number,
    itemId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/car-offers/{blockId}/items/{itemId}',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
        'itemId': itemId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @param itemId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static postContentLogCarOffersItemsImage(
    contentLogId: number,
    blockId: number,
    itemId: number,
    formData?: {
      File: Blob;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/car-offers/{blockId}/items/{itemId}/image',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
        'itemId': itemId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @param itemId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogCarOffersItemsImage(
    contentLogId: number,
    blockId: number,
    itemId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/car-offers/{blockId}/items/{itemId}/image',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
        'itemId': itemId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @param itemId
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogCarOffersItemsInfo(
    contentLogId: number,
    blockId: number,
    itemId: number,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/car-offers/{blockId}/items/{itemId}/info',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
        'itemId': itemId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @param itemId
   * @param infoId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogCarOffersItemsInfo(
    contentLogId: number,
    blockId: number,
    itemId: number,
    infoId: number,
    requestBody?: CarOfferInfoInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/car-offers/{blockId}/items/{itemId}/info/{infoId}',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
        'itemId': itemId,
        'infoId': infoId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @param itemId
   * @param infoId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogCarOffersItemsInfo(
    contentLogId: number,
    blockId: number,
    itemId: number,
    infoId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/car-offers/{blockId}/items/{itemId}/info/{infoId}',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
        'itemId': itemId,
        'infoId': infoId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param requestBody
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogDividerLines(
    contentLogId: number,
    requestBody?: BaseModuleInput,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/divider-lines',
      path: {
        'contentLogId': contentLogId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param dividerLineId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogDividerLines(
    contentLogId: number,
    dividerLineId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/divider-lines/{dividerLineId}',
      path: {
        'contentLogId': contentLogId,
        'dividerLineId': dividerLineId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param dividerLineId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static patchContentLogDividerLinesVisibility(
    contentLogId: number,
    dividerLineId: number,
    requestBody?: ContentLogIsVisisbleInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/content-log/{contentLogId}/divider-lines/{dividerLineId}/visibility',
      path: {
        'contentLogId': contentLogId,
        'dividerLineId': dividerLineId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param dividerLineId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogDividerLinesMove(
    contentLogId: number,
    dividerLineId: number,
    requestBody?: ContentLogMoveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/divider-lines/{dividerLineId}/move',
      path: {
        'contentLogId': contentLogId,
        'dividerLineId': dividerLineId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param requestBody
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogFeatures(
    contentLogId: number,
    requestBody?: BaseModuleInput,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/features',
      path: {
        'contentLogId': contentLogId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param featureId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogFeatures(
    contentLogId: number,
    featureId: number,
    requestBody?: BaseUpdateModuleInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/features/{featureId}',
      path: {
        'contentLogId': contentLogId,
        'featureId': featureId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param featureId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogFeatures(
    contentLogId: number,
    featureId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/features/{featureId}',
      path: {
        'contentLogId': contentLogId,
        'featureId': featureId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param featureId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static patchContentLogFeaturesVisibility(
    contentLogId: number,
    featureId: number,
    requestBody?: ContentLogIsVisisbleInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/content-log/{contentLogId}/features/{featureId}/visibility',
      path: {
        'contentLogId': contentLogId,
        'featureId': featureId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param featureId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogFeaturesMove(
    contentLogId: number,
    featureId: number,
    requestBody?: ContentLogMoveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/features/{featureId}/move',
      path: {
        'contentLogId': contentLogId,
        'featureId': featureId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param featureId
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogFeaturesItems(
    contentLogId: number,
    featureId: number,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/features/{featureId}/items',
      path: {
        'contentLogId': contentLogId,
        'featureId': featureId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param featureId
   * @param itemId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogFeaturesItems(
    contentLogId: number,
    featureId: number,
    itemId: number,
    requestBody?: ContentLogParagraphInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/features/{featureId}/items/{itemId}',
      path: {
        'contentLogId': contentLogId,
        'featureId': featureId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param featureId
   * @param itemId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogFeaturesItems(
    contentLogId: number,
    featureId: number,
    itemId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/features/{featureId}/items/{itemId}',
      path: {
        'contentLogId': contentLogId,
        'featureId': featureId,
        'itemId': itemId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param featureId
   * @param itemId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static postContentLogFeaturesItemsImage(
    contentLogId: number,
    featureId: number,
    itemId: number,
    formData?: {
      File: Blob;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/features/{featureId}/items/{itemId}/image',
      path: {
        'contentLogId': contentLogId,
        'featureId': featureId,
        'itemId': itemId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param featureId
   * @param itemId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogFeaturesItemsImage(
    contentLogId: number,
    featureId: number,
    itemId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/features/{featureId}/items/{itemId}/image',
      path: {
        'contentLogId': contentLogId,
        'featureId': featureId,
        'itemId': itemId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param requestBody
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogButtonsBlocks(
    contentLogId: number,
    requestBody?: BaseModuleInput,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/buttons-blocks',
      path: {
        'contentLogId': contentLogId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogButtonsBlocks(
    contentLogId: number,
    blockId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/buttons-blocks/{blockId}',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static patchContentLogButtonsBlocksVisibility(
    contentLogId: number,
    blockId: number,
    requestBody?: ContentLogIsVisisbleInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/content-log/{contentLogId}/buttons-blocks/{blockId}/visibility',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogButtonsBlocksMove(
    contentLogId: number,
    blockId: number,
    requestBody?: ContentLogMoveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/buttons-blocks/{blockId}/move',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogButtonsBlocksItems(
    contentLogId: number,
    blockId: number,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/buttons-blocks/{blockId}/items',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @param itemId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogButtonsBlocksItems(
    contentLogId: number,
    blockId: number,
    itemId: number,
    requestBody?: ButtonBlockInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/buttons-blocks/{blockId}/items/{itemId}',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param blockId
   * @param itemId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogButtonsBlocksItems(
    contentLogId: number,
    blockId: number,
    itemId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/buttons-blocks/{blockId}/items/{itemId}',
      path: {
        'contentLogId': contentLogId,
        'blockId': blockId,
        'itemId': itemId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param requestBody
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogSimpleTexts(
    contentLogId: number,
    requestBody?: BaseModuleInput,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/simple-texts',
      path: {
        'contentLogId': contentLogId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param simpleTextId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogSimpleTexts(
    contentLogId: number,
    simpleTextId: number,
    requestBody?: BaseUpdateModuleInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/simple-texts/{simpleTextId}',
      path: {
        'contentLogId': contentLogId,
        'simpleTextId': simpleTextId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param simpleTextId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogSimpleTexts(
    contentLogId: number,
    simpleTextId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/simple-texts/{simpleTextId}',
      path: {
        'contentLogId': contentLogId,
        'simpleTextId': simpleTextId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param simpleTextId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static patchContentLogSimpleTextsVisibility(
    contentLogId: number,
    simpleTextId: number,
    requestBody?: ContentLogIsVisisbleInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/content-log/{contentLogId}/simple-texts/{simpleTextId}/visibility',
      path: {
        'contentLogId': contentLogId,
        'simpleTextId': simpleTextId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param simpleTextId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogSimpleTextsMove(
    contentLogId: number,
    simpleTextId: number,
    requestBody?: ContentLogMoveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/simple-texts/{simpleTextId}/move',
      path: {
        'contentLogId': contentLogId,
        'simpleTextId': simpleTextId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param requestBody
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogNewArrivalBlocks(
    contentLogId: number,
    requestBody?: BaseModuleInput,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/new-arrival-blocks',
      path: {
        'contentLogId': contentLogId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param newArrivalBlockId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogNewArrivalBlocks(
    contentLogId: number,
    newArrivalBlockId: number,
    requestBody?: NewArrivalBlockInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/new-arrival-blocks/{newArrivalBlockId}',
      path: {
        'contentLogId': contentLogId,
        'newArrivalBlockId': newArrivalBlockId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param newArrivalBlockId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogNewArrivalBlocks(
    contentLogId: number,
    newArrivalBlockId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/new-arrival-blocks/{newArrivalBlockId}',
      path: {
        'contentLogId': contentLogId,
        'newArrivalBlockId': newArrivalBlockId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param newArrivalBlockId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static patchContentLogNewArrivalBlocksVisibility(
    contentLogId: number,
    newArrivalBlockId: number,
    requestBody?: ContentLogIsVisisbleInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/content-log/{contentLogId}/new-arrival-blocks/{newArrivalBlockId}/visibility',
      path: {
        'contentLogId': contentLogId,
        'newArrivalBlockId': newArrivalBlockId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param newArrivalBlockId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogNewArrivalBlocksMove(
    contentLogId: number,
    newArrivalBlockId: number,
    requestBody?: ContentLogMoveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/new-arrival-blocks/{newArrivalBlockId}/move',
      path: {
        'contentLogId': contentLogId,
        'newArrivalBlockId': newArrivalBlockId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param newArrivalBlockId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static postContentLogNewArrivalBlocksImage(
    contentLogId: number,
    newArrivalBlockId: number,
    formData?: {
      File: Blob;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/new-arrival-blocks/{newArrivalBlockId}/image',
      path: {
        'contentLogId': contentLogId,
        'newArrivalBlockId': newArrivalBlockId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param newArrivalBlockId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogNewArrivalBlocksImage(
    contentLogId: number,
    newArrivalBlockId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/new-arrival-blocks/{newArrivalBlockId}/image',
      path: {
        'contentLogId': contentLogId,
        'newArrivalBlockId': newArrivalBlockId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param newArrivalBlockId
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogNewArrivalBlocksSpecifications(
    contentLogId: number,
    newArrivalBlockId: number,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/new-arrival-blocks/{newArrivalBlockId}/specifications',
      path: {
        'contentLogId': contentLogId,
        'newArrivalBlockId': newArrivalBlockId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param newArrivalBlockId
   * @param specificationId
   * @param requestBody
   * @returns number Created
   * @throws ApiError
   */
  public static putContentLogNewArrivalBlocksSpecifications(
    contentLogId: number,
    newArrivalBlockId: number,
    specificationId: number,
    requestBody?: BaseModuleInput,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/new-arrival-blocks/{newArrivalBlockId}/specifications/{specificationId}',
      path: {
        'contentLogId': contentLogId,
        'newArrivalBlockId': newArrivalBlockId,
        'specificationId': specificationId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param newArrivalBlockId
   * @param specificationId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogNewArrivalBlocksSpecifications(
    contentLogId: number,
    newArrivalBlockId: number,
    specificationId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/new-arrival-blocks/{newArrivalBlockId}/specifications/{specificationId}',
      path: {
        'contentLogId': contentLogId,
        'newArrivalBlockId': newArrivalBlockId,
        'specificationId': specificationId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param newArrivalBlockId
   * @param specificationId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static postContentLogNewArrivalBlocksSpecificationsImage(
    contentLogId: number,
    newArrivalBlockId: number,
    specificationId: number,
    formData?: {
      File: Blob;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/new-arrival-blocks/{newArrivalBlockId}/specifications/{specificationId}/image',
      path: {
        'contentLogId': contentLogId,
        'newArrivalBlockId': newArrivalBlockId,
        'specificationId': specificationId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param newArrivalBlockId
   * @param specificationId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogNewArrivalBlocksSpecificationsImage(
    contentLogId: number,
    newArrivalBlockId: number,
    specificationId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/new-arrival-blocks/{newArrivalBlockId}/specifications/{specificationId}/image',
      path: {
        'contentLogId': contentLogId,
        'newArrivalBlockId': newArrivalBlockId,
        'specificationId': specificationId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param newArrivalBlockId
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogNewArrivalBlocksButtons(
    contentLogId: number,
    newArrivalBlockId: number,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/new-arrival-blocks/{newArrivalBlockId}/buttons',
      path: {
        'contentLogId': contentLogId,
        'newArrivalBlockId': newArrivalBlockId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param newArrivalBlockId
   * @param buttonId
   * @param requestBody
   * @returns number Created
   * @throws ApiError
   */
  public static putContentLogNewArrivalBlocksButtons(
    contentLogId: number,
    newArrivalBlockId: number,
    buttonId: number,
    requestBody?: ButtonBlockInput,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/new-arrival-blocks/{newArrivalBlockId}/buttons/{buttonId}',
      path: {
        'contentLogId': contentLogId,
        'newArrivalBlockId': newArrivalBlockId,
        'buttonId': buttonId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param newArrivalBlockId
   * @param buttonId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogNewArrivalBlocksButtons(
    contentLogId: number,
    newArrivalBlockId: number,
    buttonId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/new-arrival-blocks/{newArrivalBlockId}/buttons/{buttonId}',
      path: {
        'contentLogId': contentLogId,
        'newArrivalBlockId': newArrivalBlockId,
        'buttonId': buttonId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param requestBody
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogTextWithSideImages(
    contentLogId: number,
    requestBody?: BaseModuleInput,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/text-with-side-images',
      path: {
        'contentLogId': contentLogId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param textWithSideImageId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogTextWithSideImages(
    contentLogId: number,
    textWithSideImageId: number,
    requestBody?: TextWithSideImageInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/text-with-side-images/{textWithSideImageId}',
      path: {
        'contentLogId': contentLogId,
        'textWithSideImageId': textWithSideImageId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param textWithSideImageId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogTextWithSideImages(
    contentLogId: number,
    textWithSideImageId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/text-with-side-images/{textWithSideImageId}',
      path: {
        'contentLogId': contentLogId,
        'textWithSideImageId': textWithSideImageId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param textWithSideImageId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static patchContentLogTextWithSideImagesVisibility(
    contentLogId: number,
    textWithSideImageId: number,
    requestBody?: ContentLogIsVisisbleInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/content-log/{contentLogId}/text-with-side-images/{textWithSideImageId}/visibility',
      path: {
        'contentLogId': contentLogId,
        'textWithSideImageId': textWithSideImageId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param textWithSideImageId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogTextWithSideImagesMove(
    contentLogId: number,
    textWithSideImageId: number,
    requestBody?: ContentLogMoveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/text-with-side-images/{textWithSideImageId}/move',
      path: {
        'contentLogId': contentLogId,
        'textWithSideImageId': textWithSideImageId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param textWithSideImageId
   * @param formData
   * @returns any Success
   * @throws ApiError
   */
  public static postContentLogTextWithSideImagesImage(
    contentLogId: number,
    textWithSideImageId: number,
    formData?: {
      File: Blob;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/text-with-side-images/{textWithSideImageId}/image',
      path: {
        'contentLogId': contentLogId,
        'textWithSideImageId': textWithSideImageId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param contentLogId
   * @param textWithSideImageId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogTextWithSideImagesImage(
    contentLogId: number,
    textWithSideImageId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/text-with-side-images/{textWithSideImageId}/image',
      path: {
        'contentLogId': contentLogId,
        'textWithSideImageId': textWithSideImageId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param requestBody
   * @returns number Created
   * @throws ApiError
   */
  public static postContentLogHeaders(
    contentLogId: number,
    requestBody?: BaseModuleInput,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/content-log/{contentLogId}/headers',
      path: {
        'contentLogId': contentLogId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param headerId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogHeaders(
    contentLogId: number,
    headerId: number,
    requestBody?: UpdateHeaderInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/headers/{headerId}',
      path: {
        'contentLogId': contentLogId,
        'headerId': headerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param headerId
   * @returns any Success
   * @throws ApiError
   */
  public static deleteContentLogHeaders(
    contentLogId: number,
    headerId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/content-log/{contentLogId}/headers/{headerId}',
      path: {
        'contentLogId': contentLogId,
        'headerId': headerId,
      },
    });
  }

  /**
   * @param contentLogId
   * @param headerId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static patchContentLogHeadersVisibility(
    contentLogId: number,
    headerId: number,
    requestBody?: ContentLogIsVisisbleInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/content-log/{contentLogId}/headers/{headerId}/visibility',
      path: {
        'contentLogId': contentLogId,
        'headerId': headerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param contentLogId
   * @param headerId
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static putContentLogHeadersMove(
    contentLogId: number,
    headerId: number,
    requestBody?: ContentLogMoveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/content-log/{contentLogId}/headers/{headerId}/move',
      path: {
        'contentLogId': contentLogId,
        'headerId': headerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

}
